//https://getbootstrap.com/docs/5.0/components/modal/
const apiMsg = {
    /*
            apiMsg.msgFetchErr(
            "PRUEBA DE MENSAJE",
            "ESTO ES UNA PRUEBA",
            [
                { texto: "Aceptar", className: "btn btn-success", onClick: () => { acciónAceptar() } },
                { texto: "Cancelar", className: "btn btn-secondary", onClick: () => { acciónCancelar() } }
            ]
        );
    */
    msgFetchErr(stMsg, stTitulo, botones = []) {
            //if (stTitulo) document.getElementById("msg-modal-head").innerHTML = stTitulo
            //if (stMsg) document.getElementById("msg-modal-body").innerHTML = "<h4>" + stMsg + "</h4>"
            //$("#primary-header-modal").modal('show');
            this.showCustomModal(stMsg, stTitulo, botones);
    },
    msgOk(stMsg, stTitulo, botones = []) {
        // if (stTitulo) document.getElementById("msg-modal-head").innerHTML = stTitulo
        // if (stMsg) document.getElementById("msg-modal-body").innerHTML = "<h4>" + stMsg + "</h4>"
        // $("#primary-header-modal").modal('show');
        if (botones.length === 0) {
            botones = [
                { texto: "Aceptar", className: "btn btn-info", onClick: () => { $("#primary-header-modal").modal('hide'); } }
            ];
        }
        this.showCustomModal(stMsg, stTitulo, botones);
    },
    msgOkCancel(stMsg, stTitulo, botones = []) {
        // if (stTitulo) document.getElementById("msg-modal-head").innerHTML = stTitulo
        // if (stMsg) document.getElementById("msg-modal-body").innerHTML = "<h4>" + stMsg + "</h4>"
        // $("#primary-header-modal").modal('show');
        if (botones.length === 0) {
            botones = [
                { texto: "Aceptar", className: "btn btn-info", onClick: () => { $("#primary-header-modal").modal('hide'); } }
            ];
        }
        this.showCustomModal( stMsg,stTitulo, botones);
    },
    cancelarAccion (stMsg,stTitulo){
        apiMsg.msgOk(stMsg || "Se ha cancelado la Acción", stTitulo || "Cancelar Acción");
    },
    showCustomModal(stMsg, stTitulo, botones = []) {
        try {
            let modal = document.getElementById("primary-header-modal");
            if (!modal) {
                modal = document.createElement("div");
                modal.className = "modal fade";
                modal.id = "primary-header-modal";
                modal.tabIndex = -1;
                modal.setAttribute("aria-labelledby", "msg-modal-head");
                modal.setAttribute("aria-hidden", "true");
                modal.innerHTML = `
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="msg-modal-head" style="color:#c0392b; font-weight:700;"></h4>
                        <button type="button" data-bs-dismiss="modal" aria-label="Cerrar" onclick="$('#primary-header-modal').modal('hide');" style="background: none; border: none;">
                          <span style="font-size:1.5rem; color: red; font-weight: bold; cursor: pointer;">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body" id="msg-modal-body"></div>
                      <div class="modal-footer" id="msg-modal-buttons"></div>
                    </div>
                  </div>
                `;
                document.body.appendChild(modal);
            }
            document.getElementById("msg-modal-head").innerHTML = stTitulo || "";
            const lines = (stMsg || "").split('\n').filter(l => l.trim());
            document.getElementById("msg-modal-body").innerHTML = `<p style="font-size:1rem; margin:0;">${lines.join('<br>')}</p>`;
            const btnContainer = document.getElementById("msg-modal-buttons");
            if (btnContainer) {
                btnContainer.innerHTML = '';
                botones.forEach(btn => {
                    const button = document.createElement('button');
                    button.innerText = btn.texto;
                    button.className = btn.className || 'btn btn-primary';
                    if (typeof btn.onClick === 'function') {
                        button.onclick = btn.onClick;
                    }
                    btnContainer.appendChild(button);
                });
            }
            $("#primary-header-modal").modal('show');
        } catch (error) {
            console.error(error);
        }
    },
}
export default apiMsg;